import { FormVariant } from "@comparaonline/car-dealer-chile";
import { getConfig } from "../../config/app";
import fetch from "isomorphic-unfetch";

const JSON_API_MEDIA_TYPE = "application/vnd.api+json";

enum FormType {
  RedirectQuoteForm = "redirect-quote-form",
  ContactClient = "contact-client",
  ContactClientOrRedirectQuoteForm = "contact-client-or-redirect-quote-form",
  ImmediateRedirectQuoteForm = "immediate-redirect-quote-form"
}

interface CarDealersResponse {
  data: {
    type: string;
    id: string;
    attributes: {
      name: string;
      slug: string;
      formType: FormType[];
    };
  }[];
}

interface CarDealer {
  name: string;
  slug: string;
  variant: FormVariant[];
}

const formTypeMap = {
  [FormType.RedirectQuoteForm]: FormVariant.RedirectQuoteForm,
  [FormType.ContactClient]: FormVariant.ContactClient,
  [FormType.ContactClientOrRedirectQuoteForm]: FormVariant.ContactClientOrRedirectQuoteForm,
  [FormType.ImmediateRedirectQuoteForm]: FormVariant.ImmediateRedirectQuoteForm
};

export const getCarDealers = async (): Promise<CarDealer[]> => {
  const bffUrl = getConfig("bff.cicl");
  const response: CarDealersResponse = await fetch(`${bffUrl}/car-dealers`, {
    headers: {
      "Content-Type": JSON_API_MEDIA_TYPE,
      Accept: JSON_API_MEDIA_TYPE
    }
  }).then(response => response.json());
  return response.data.map(({ attributes }) => ({
    ...attributes,
    variant: attributes.formType.map(formType => formTypeMap[formType])
  }));
};
